var PauseTyping = function () {
    // Pause typing
    this.typeWriter.pauseTyping();

    return this;
}

export default PauseTyping;